// libraries.
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// slices.
import { DocumentsTool } from '../../../../DocumentsVisualizer/interfaces/sideBar.types';
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// components.
import { ButtonSidebar } from '@shared';

// assets.
import { IconDocumentTool } from '@assets/icons';

export const ButtonDocumentsViewer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectSidebarButton(DocumentsTool.visualizer));
    navigate('/document-audit/visualizer');
  };

  return (
    <ButtonSidebar
      icon={<IconDocumentTool fill="white" />}
      text="Visualizador"
      onClick={handleClick}
    />
  );
};
